import React from 'react';
import { DataTableMeta, ActionsColumn, DateColumn } from '@otp/ui';
import { TFunction } from 'i18next';

import { User } from 'src/graphql/generated/graphql';
import { UserLevelColumn } from '../../../common/table/columns/level';
import { UsernameEmail } from './columns/username-email';
import { getUserLevels } from 'src/utils/user-data';

export const getTableConfig = (
  users: Partial<User>[],
  {
    t,
  }: {
    t: TFunction;
  },
) => [
  {
    name: 'lastName',
    label: t('manage-otps.name'),
    options: {
      sort: true,
      customBodyRender: (value: any, column: DataTableMeta) => {
        const rowData = users[column.rowIndex];
        return <UsernameEmail user={rowData} options={{ nameOnly: true }} />;
      },
    },
  },
  {
    name: 'email',
    label: t('manage-otps.email'),
    options: {
      sort: false,
    },
  },
  {
    name: 'mcId',
    label: t('manage-otps.eid'),
    options: {
      sort: false,
    },
  },
  {
    name: 'programs',
    label: t('manage-otps.level'),
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const user = users[column.rowIndex];
        const userLevels = getUserLevels(user);
        return userLevels.map((level) => (
          <UserLevelColumn key={level} level={level} />
        ));
      },
      sort: false,
    },
  },
  {
    name: 'storesCount',
    label: t('manage-otps.stores'),
    options: {
      sort: false,
    },
  },
  {
    name: 'updatedAt',
    label: t('manage-otps.last-time-active'),
    options: {
      customBodyRender: (value: any, column: DataTableMeta) => {
        const rowData = users[column.rowIndex];
        return <DateColumn date={rowData.updatedAt} />;
      },
      sort: true,
    },
  },
  {
    name: 'actions',
    label: t('common.actions'),
    options: {
      customBodyRender: () => {
        return <ActionsColumn />;
      },
      sort: false,
    },
  },
];
